const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');

const Button = require('app/www/components/blocks/Button/Button');
const ButtonWrapper = require('app/www/components/blocks/ButtonWrapper/ButtonWrapper');
const Global = require('app/www/components/blocks/Global/Global');
const Ua = require('app/www/components/blocks/Ua/Ua');

class Button_Episodes extends React.PureComponent {
    constructor(props) {
        super(props);

        this._showButton = Global.isRussia && !Ua.isOldOpera && !Ua.isOldIE;

        this._onClick = this._onClick.bind(this);
    }

    render() {
        if (!this._showButton) {
            return null;
        }

        const {i18n, children} = this.props;

        const buttonWrapperProps = {
            mods: {
                episodes: true,
            },
        };

        const buttonProps = Object.assign({}, this.props, {
            onClick: this._onClick,
            children: children || i18n.get('button.episodes'),
        });

        return (
            <ButtonWrapper {...buttonWrapperProps}>
                <Button ref={ref => (this.button = ref)} {...buttonProps} />
            </ButtonWrapper>
        );
    }

    /**
     * Обработчик нажатия на кнопку
     * @private
     */
    _onClick(evt) {
        evt.preventDefault();
        this.props.onClick();
    }
}

Button_Episodes.defaultProps = {
    onClick: () => {},
};

Button_Episodes.propTypes = {
    onClick: PropTypes.func,
    mods: Button.propTypes.mods,
};

module.exports = withI18n(Button_Episodes);
